import request from "superagent";
import Promise from "promise";

export default {
    getItems(
        query,
        take,
        skip,
        culture,
        types,
        startPageId,
        currentPageId,
        takeNrFromPage,
        isMixedContent,
        orderByDate,
        categories,
        categoryTags
    ) {
        var queryObj = {
            query: typeof query === "undefined" ? "" : query,
            take: take,
            skip: skip,
            currentCulture: culture,
            documentTypes: types,
            startPageId: startPageId,
            currentPageId: currentPageId,
            takeNrFromPage: takeNrFromPage,
            isMixedContent: isMixedContent,
            orderByDate: orderByDate,
            categories: categories ? categories : null,
            categoryTags: categoryTags ? categoryTags : null
        };

        var targetUrl = `/umbraco/api/search`;

        return new Promise((resolve, reject) => {
            request
                .post(targetUrl)
                .send(queryObj)
                .end((error, response) => {
                    if (response.ok) {
                        resolve(response.body);
                    } else {
                        reject("Error");
                    }
                });
        });
    },
};
